import {
  Typography,
  Box,
  Stack,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Button,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Divider,
  FormControlLabel,
  Paper,
} from "@mui/material";
import { useEffect, useState } from "react";
import Block from "../../components/Block";
import DatePickerCustom2 from "../../components/DatePicker2";
import dayjs from "dayjs";
import { AgGridReact } from "ag-grid-react";
import { getOrdersStatistics } from "../../distflowAPI/ordersApi";
import { downloadFile } from "../../distflowAPI/downloadFile";
import groupsApi from "../../distflowAPI/groupsApi";
function ProfitAndLoss() {
  const [startDate, setStartDate] = useState(dayjs().subtract(7, "days"));
  const [endDate, setEndDate] = useState(dayjs());
  const [asOfToday, setAsOfToday] = useState(true);
  const [excludePostDated, setExcludePostDated] = useState(false);
  return (
    <Box maxWidth="1525px" margin=" 30px auto 0">
      <Stack spacing={3}>
        <ProfitAndLossConfig
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          asOfToday={asOfToday}
          setAsOfToday={setAsOfToday}
          excludePostDated={excludePostDated}
          setExcludePostDated={setExcludePostDated}
        />
      </Stack>
    </Box>
  );
}

function ProfitAndLossConfig(props) {
  const [typesOpen, setTypesOpen] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [accountTypes, setAccountTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedAccountTypes, setSelectedAccountTypes] = useState({
    NONE: false,
  });
  useEffect(() => {
    setIsLoading(true);
    groupsApi.list(100, 1, [], [], null).then((res) => {
      const newSelected = { ...selectedAccountTypes };
      setAccountTypes([{ id: "NONE", name: "No Group" }, ...res.results]);
      res.results.map((acc) => {
        newSelected[acc.id] = false;
      });
      setSelectedAccountTypes(newSelected);
      setIsLoading(false);
    });
  }, []);
  return (
    <Stack spacing={3}>
      <Block>
        <Typography variant="h6" fontWeight={600} mb={3}>
          Profit and Loss Report
        </Typography>

        {/* Date Range & Options Section */}
        <Grid container spacing={3} alignItems="center" mb={3}>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" color="text.secondary" mb={1}>
              Date Range
            </Typography>
            <Stack direction="row" spacing={2}>
              <DatePickerCustom2
                label="Start Date"
                controlledValue={props.startDate}
                setControlledValue={props.setStartDate}
              />
              <DatePickerCustom2
                label="End Date"
                controlledValue={props.endDate}
                setControlledValue={props.setEndDate}
              />
            </Stack>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" color="text.secondary" mb={1}>
              Options
            </Typography>
            <Stack direction="row" spacing={2}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={props.asOfToday}
                    onChange={(e) => props.setAsOfToday(e.target.checked)}
                    size="small"
                  />
                }
                label="As of today"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={props.excludePostDated}
                    onChange={(e) =>
                      props.setExcludePostDated(e.target.checked)
                    }
                    size="small"
                  />
                }
                label="Exclude Post Dated"
              />
            </Stack>
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />

        {/* Export Buttons Section */}
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" color="text.secondary" mb={1.5}>
              Export by Date Range
            </Typography>
            <Stack direction="row" spacing={1.5} flexWrap="wrap" useFlexGap>
              <Button
                variant="contained"
                size="small"
                onClick={() =>
                  downloadFile(
                    `/api/orders/statistics/?start_date=${props.startDate.format(
                      "YYYY-MM-DD"
                    )}&end_date=${props.endDate.format("YYYY-MM-DD")}`,
                    "items_statistics.csv"
                  )
                }
              >
                Items
              </Button>
              <Button
                variant="contained"
                size="small"
                onClick={() => setTypesOpen(true)}
              >
                Items/Customer
              </Button>
              <Button
                variant="contained"
                size="small"
                onClick={() =>
                  downloadFile(
                    `/api/accounting/invoice_statistics/?start_date=${props.startDate.format(
                      "YYYY-MM-DD"
                    )}&end_date=${props.endDate.format("YYYY-MM-DD")}&as_of_today=${props.asOfToday}&exclude_post_dated=${props.excludePostDated}`,
                    "invoices_statistics.csv"
                  )
                }
              >
                Invoices
              </Button>
              <Button
                variant="contained"
                size="small"
                onClick={() =>
                  downloadFile(
                    `/api/accounting/invoice_statistics_pesach/?start_date=${props.startDate.format(
                      "YYYY-MM-DD"
                    )}&end_date=${props.endDate.format("YYYY-MM-DD")}&as_of_today=${props.asOfToday}&exclude_post_dated=${props.excludePostDated}`,
                    "invoices_statistics_pesach.csv"
                  )
                }
              >
                Invoices (Pesach)
              </Button>
              <Button
                variant="contained"
                size="small"
                onClick={() =>
                  downloadFile(
                    `/api/accounting/invoice_statistics_by_customer/?start_date=${props.startDate.format(
                      "YYYY-MM-DD"
                    )}&end_date=${props.endDate.format("YYYY-MM-DD")}&as_of_today=${props.asOfToday}&exclude_post_dated=${props.excludePostDated}`,
                    "invoices_statistics_by_customer.csv"
                  )
                }
              >
                Customers
              </Button>
            </Stack>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" color="text.secondary" mb={1.5}>
              Historical Reports
            </Typography>
            <Stack direction="row" spacing={1.5} flexWrap="wrap" useFlexGap>
              <Button
                variant="outlined"
                size="small"
                color="success"
                onClick={() =>
                  downloadFile(
                    `/api/accounting/customers_sales_monthly/`,
                    "invoices_month_to_month_by_customer.csv"
                  )
                }
              >
                Customers Month to Month
              </Button>
              <Button
                variant="outlined"
                size="small"
                color="success"
                onClick={() =>
                  downloadFile(
                    `/api/accounting/customers_sales_weekly_itemized/`,
                    "invoices_month_to_month_by_customer_itemized.csv"
                  )
                }
              >
                Customers Month to Month Itemized
              </Button>
            </Stack>
          </Grid>
        </Grid>

        {/* Dialog for Items/Customer export */}
        <Dialog
          open={typesOpen}
          onClose={() => setTypesOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography variant="h6">Select Account Types</Typography>
              <Stack direction="row" spacing={1}>
                <Button
                  size="small"
                  onClick={() => {
                    const newSelected = { ...selectedAccountTypes };
                    Object.keys(newSelected).map((k) => {
                      newSelected[k] = true;
                    });
                    setSelectedAccountTypes(newSelected);
                  }}
                >
                  Select All
                </Button>
                <Button
                  size="small"
                  onClick={() => {
                    const newSelected = { ...selectedAccountTypes };
                    Object.keys(newSelected).map((k) => {
                      newSelected[k] = false;
                    });
                    setSelectedAccountTypes(newSelected);
                  }}
                >
                  Deselect All
                </Button>
              </Stack>
            </Stack>
          </DialogTitle>
          <DialogContent dividers>
            {isLoading && <Typography>Loading...</Typography>}
            <Grid container spacing={1}>
              {accountTypes.map((acc) => (
                <Grid item xs={6} key={acc.id}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        onChange={(e) => {
                          setSelectedAccountTypes({
                            ...selectedAccountTypes,
                            [acc.id]: e.target.checked,
                          });
                        }}
                        checked={selectedAccountTypes[acc.id]}
                      />
                    }
                    label={acc.name}
                  />
                </Grid>
              ))}
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setTypesOpen(false)} color="inherit">
              Cancel
            </Button>
            <Button
              variant="contained"
              disabled={isExporting || isLoading}
              onClick={() => {
                setIsExporting(true);
                downloadFile(
                  `/api/orders/statistics_grouped/?start_date=${props.startDate.format(
                    "YYYY-MM-DD"
                  )}&end_date=${props.endDate.format("YYYY-MM-DD")}&selectedTypes=${Object.keys(
                    selectedAccountTypes
                  )
                    .filter((k) => selectedAccountTypes[k])
                    .map((k) => k)}`,
                  "items_statistics.csv"
                ).finally(() => {
                  setIsExporting(false);
                  setTypesOpen(false);
                });
              }}
            >
              Export
            </Button>
          </DialogActions>
        </Dialog>
      </Block>

      <Block>
        <LossTable start_date={props.startDate} end_date={props.endDate} />
      </Block>
    </Stack>
  );
}

function ProfitAndLossSummary() {}

function ProfitTable() {}

function LossTable({ start_date, end_date }) {
  const [data, setData] = useState([]);
  useEffect(() => {
    return;
    getOrdersStatistics(
      start_date.format("YYYY-MM-DD"),
      end_date.format("YYYY-MM-DD"),
      "vendors_report"
    ).then((res) => setData(res.data.data));
  }, [start_date, end_date]);

  return (
    <div style={{ width: "100%" }} className="ag-theme-alpine">
      <AgGridReact
        animateRows
        domLayout="autoHeight"
        rowData={data}
        columnDefs={[
          {
            headerName: "date",
            field: "date",
            sortable: true,
          },
          {
            headerName: "Product",
            field: "name",
            sortable: true,
          },
          {
            headerName: "SKU",
            field: "sku",
            sortable: true,
          },
          {
            headerName: "Vendor",
            field: "vendor",
            sortable: true,
          },
          {
            headerName: "total cost",
            field: "total_cost",
            sortable: true,
            cellRenderer: (params) => `$${params.data.total_cost}`,
          },
          {
            headerName: "quantity sold",
            field: "delivered_qty",
            sortable: true,
          },
          {
            headerName: "total sales",
            field: "total_price",
            sortable: true,
            cellRenderer: (params) => `$${params.data.total_price}`,
          },
        ]}
        //defaultColDef={defaultColDef}
        suppressSorting={true} //disable default sorting
        rowHeight={33}
        headerHeight={42}
      />
    </div>
  );
}

export default ProfitAndLoss;

/*

  IDEA

  <i---- header ------i>
  <start date> <end date>
  
  <part one: summary>
  <total orders> <total delivered> <total delivered> <total cost> <total income> <total upcoming income>

  <part two>
  <Table 1>
    <summary of cost by vendor>
  </table 1>
  <Table 2>
    <summary of income by account>
  </table 2>

*/
